import { useEffect } from 'react';

type KeyboardShortcut = string;
type ShortcutCallback = () => void;

const useKeyboardShortcut = (shortcut: KeyboardShortcut, callback: ShortcutCallback) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            const isCtrl = shortcut.toLowerCase().includes('ctrl') && (event.ctrlKey || event.metaKey);
            const key = shortcut.split('+')[1];

            if (isCtrl && event.key.toLowerCase() === key) {
                event.preventDefault();
                callback();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [shortcut, callback]);
};

export default useKeyboardShortcut; 